module.exports = __webpack_public_path__ + "img/invitation-ja.f5cce3ac.png";